(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-banner-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBannerSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initBannerSwiper, 50);
      return;
    }
    document.querySelectorAll('.banner-swiper').forEach(function (el) {
      if (el.dataset.swiperInit) return;
      el.dataset.swiperInit = '1';
      var swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true
        }
      });
      if (swiper && swiper.autoplay && typeof swiper.autoplay.start === 'function') {
        swiper.autoplay.start();
      }
      setInterval(function () {
        if (swiper && typeof swiper.slideNext === 'function') {
          swiper.slideNext();
        }
      }, 4000);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBannerSwiper);
  } else {
    initBannerSwiper();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
